import axios from "axios";
import router from "../../router";
export default {
  namespaced: true,
  state: {
    token: "",
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : "",
  },

  mutations: {
    SET_TOKEN(state, token) {
      if (token && token != null) {
        state.token = token;
        localStorage.setItem("token", state.token);
      } else {
        localStorage.removeItem("token");
        state.token = "";
      }
    },
    SET_USER(state, user) {
      state.user = user;
      if (state.user) {
        localStorage.setItem("user", JSON.stringify(state.user));
      } else {
        localStorage.removeItem("user");
        router.push({ name: "Login" });
      }
    },
    LOGOUT(state) {
      state.user = "";
      state.token = "";
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },

  actions: {
    async changeCredential({ commit, dispatch }, credentials) {
      this.state.Global.loader = true;
      await axios
        .post("changeCredential", credentials)
        .then((response) => {
          this.state.Global.loader = false;
          var data = response.data.data;
          commit("SET_USER", data);
          dispatch(
            "Global/alert",
            {
              value: true,
              text: response.data.message,
              type: "success",
            },
            { root: true }
          );
          router.push({ name: "Home" });
        })
        .catch((err) => {
          this.state.Global.loader = false;
          dispatch(
            "Global/alert",
            {
              value: true,
              text: err.response.data.message,
              type: "error",
            },
            { root: true }
          );
        });
    },
    async signin({ commit, dispatch }, credentials) {
      this.state.Global.loader = true;
      await axios
        .post("login", credentials)
        .then((response) => {
          this.state.Global.loader = false;
          var data = response.data.data;
          commit("SET_USER", data);
          dispatch(
            "Global/alert",
            {
              value: true,
              text: response.data.message,
              type: "success",
            },
            { root: true }
          );
          router.push({ name: "Home" });
        })
        .catch((err) => {
          this.state.Global.loader = false;
          dispatch(
            "Global/alert",
            {
              value: true,
              text: err.response.data.message,
              type: "error",
            },
            { root: true }
          );
        });
    },
    signUp({ commit }, credentials) {
      return axios.post("register", credentials);
    },
    async getUser({ commit }, credentials) {
      this.state.Global.loader = true;
      await axios
        .post("profile", { email: credentials })
        .then((response) => {
          var data = response.data.data;
          console.log(data);
          this.state.Global.loader = false;
          commit("SET_USER", data);
        })
        .catch((err) => {
          this.state.Global.loader = false;
        });
    },
    signOut({ commit, state, dispatch }) {
      commit("SET_USER", "");
      dispatch(
        "Global/alert",
        {
          value: true,
          text: "Anda berhasil keluar aplikasi",
          type: "success",
        },
        { root: true }
      );
    },
  },

  getters: {
    authenticated(state) {
      return state.token && state.user;
    },
    user(state) {
      return state.user;
    },
    token(state) {
      return state.token;
    },
  },
};
